import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import type { ChapterStatus } from '@shared/types';

export function useChapterStatus() {
  return useQuery({
    queryKey: ['me', 'chapter-status'],
    queryFn: () => api.get<{ statuses: ChapterStatus[] }>('/me/chapter-status'),
    staleTime: 30_000,
  });
}
